export const itemSelectionList = 
{
    "Aircon Services" :
        [
            "General Servicing",
            "Gas Refill Full Tank",
            "Gas Refill Half Tank",
            "Chemical Wash",
            "Chemical Overhaul",
            "Condenser Cleaning",
            "Condenser Chem. Wash",
            "Drain Pipe Flush",
            "Other Cost"
        ]  ,
    "Domestic Services" :
        [
            "Other Cost"
        ]  ,
    "Handyman Services" :
        [
            "Other Cost",
            "Handyman Visit Cost"
        ]
}

export const userItemSelectionList = 
{
    "Aircon Services" :
        [
            "General Servicing", 
            "Gas Refill Full Tank",        
            "Chemical Overhaul",
            "Chemical Wash",
            "Gas Refill Half Tank",            
            "Condenser Cleaning",
            "Condenser Chem. Wash"
        ],
    "Domestic Services" :
        [
            "Other Cost"
        ] ,
    "Handyman Services" :
        [
            "Other Cost"
        ]  
    
}

